import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLazyQuery } from '@apollo/client';
import { GET_ME } from '../graphql/user';

const OAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [getMe] = useLazyQuery(GET_ME);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const token = searchParams.get('token');
        const errorMessage = searchParams.get('message');

        if (errorMessage) {
          setError(decodeURIComponent(errorMessage));
          setLoading(false);
          setTimeout(() => {
            navigate('/login');
          }, 3000);
          return;
        }

        if (!token) {
          setError('未收到認證令牌，請重試');
          setLoading(false);
          setTimeout(() => {
            navigate('/login');
          }, 3000);
          return;
        }

        // 保存 token
        localStorage.setItem('token', token);

        // 獲取使用者信息
        try {
          const { data, error: queryError } = await getMe();
          
          if (queryError) {
            throw queryError;
          }
          
          if (data && data.me) {
            authLogin({
              user: data.me,
              token: token
            });
            
            // 檢查是否是新使用者
            const isNew = searchParams.get('isNew') === 'true';
            
            setLoading(false);
            
            if (isNew) {
              // 新使用者，重定向到個人資料頁面
              navigate('/profile');
            } else {
              // 現有使用者，重定向到首頁
              navigate('/');
            }
          } else {
            throw new Error('無法獲取使用者信息');
          }
        } catch (err) {
          console.error('Failed to fetch user info:', err);
          setError('登入成功，但無法獲取使用者信息');
          setLoading(false);
          setTimeout(() => {
            navigate('/profile');
          }, 2000);
        }
      } catch (err) {
        console.error('OAuth callback error:', err);
        setError('登入過程發生錯誤');
        setLoading(false);
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate, authLogin, getMe]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">正在處理登入...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white shadow-md rounded-lg p-6">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <svg
                className="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <h3 className="mt-4 text-lg font-medium text-gray-900">登入失敗</h3>
            <p className="mt-2 text-sm text-gray-500">{error}</p>
            <p className="mt-4 text-sm text-gray-400">正在跳轉到登入頁面...</p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default OAuthCallback;

